import React from "react";
import { createPopper } from "@popperjs/core";
import { ChevronDown, ChevronUp } from "react-feather";
import user from "../img/user.png";
import { connect } from "react-redux";
import { LogOut } from "store/index";
import { Link, withRouter } from "react-router-dom";

const Dropdown = (allprops) => {
  return <></>;
};

function DropdownRender(props) {
  let color = "white";
  // dropdown props
  const [dropdownPopoverShow, setDropdownPopoverShow] = React.useState(false);
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const openDropdownPopover = () => {
    createPopper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownPopoverShow(true);
  };
  const closeDropdownPopover = () => {
    setDropdownPopoverShow(false);
  };
  function addDefaultSrc(ev) {
    ev.target.src = user;
  }
  // bg colors
  let bgColor;
  color === "white"
    ? (bgColor = "bg-blueGray-700")
    : (bgColor = "bg-" + color + "-500");
  return (
    <>
      <div>
        <div className="flex flex-wrap mr-3">
          <div className="">
            <div className="relative inline-flex align-middle w-full outline-none">
              <button
                className={
                  "font-medium relative flex  fsize18 px-4 rounded   outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 " +
                  bgColor
                }
                type="button"
                ref={btnDropdownRef}
              >
                <img
                  onError={addDefaultSrc}
                  src={
                    props.Profile
                      ? props.Profile.Data.userProfiledata
                        ? process.env.REACT_APP_IMAGE_BASE_MG +
                          "/" +
                          props.Profile.Data.userProfiledata.u_profilePic
                        : ""
                      : ""
                  }
                  alt="user"
                  onClick={() =>
                    props.history.push(
                      `${process.env.PUBLIC_URL}/Career/profile`
                    )
                  }
                  className="h-50px w-50px m-auto rounded-full"
                />

                <div
                  className="ml-2 absolute  user-top-b"
                  onClick={() => {
                    dropdownPopoverShow
                      ? closeDropdownPopover()
                      : openDropdownPopover();
                  }}
                >
                  {!dropdownPopoverShow && (
                    <ChevronDown
                      size={25}
                      className="absolute profile-menu-icon  text-primary"
                    />
                  )}
                  {dropdownPopoverShow && (
                    <ChevronUp
                      size={25}
                      className="absolute profile-menu-icon  text-primary"
                    />
                  )}
                </div>
              </button>
              <div
                ref={popoverDropdownRef}
                className={
                  (dropdownPopoverShow ? "block " : "hidden ") +
                  (color === "white" ? "bg-white " : bgColor + " ") +
                  "text-base z-50 float-left px-4 ml-10px py-2 list-none text-left rounded shadow-lg mt-1 drop-rad-shadow"
                }
                style={{ minWidth: "14rem" }}
              >
                <a
                  href="#pablo"
                  className={
                    "text-sm p-4 font-normal cust-border-b fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  onClick={(e) => e.preventDefault()}
                >
                  Jobs
                </a>
                <a
                  href="#pablo"
                  className={
                    "text-sm p-4 font-normal cust-border-b fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  onClick={(e) => e.preventDefault()}
                >
                  Our Courses
                </a>
                <a
                  href="#pablo"
                  className={
                    "text-sm p-4 font-normal cust-border-b fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  onClick={(e) => e.preventDefault()}
                >
                  Programmes
                </a>
                <a
                  href="#pablo"
                  className={
                    "text-sm p-4 font-normal cust-border-b fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  onClick={(e) => e.preventDefault()}
                >
                  Know Us More
                </a>
                {/* <div className="h-0 my-2  opacity-25" /> */}
                <a
                  href="#pablo"
                  className={
                    "text-sm p-4 font-normal cust-border-b fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  onClick={(e) => e.preventDefault()}
                >
                  What's News
                </a>
                <Link
                  to="/CareerApplicant/career/itv"
                  className={
                    "text-sm p-4 fsize18 font-normal cust-border-b block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  // onClick={(e) => e.preventDefault()}
                >
                  ITV
                </Link>
                {/* <a
                  href="#pablo"
                  className={
                    "text-sm py-2 px-4 font-normal cust-border-b fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  // onClick={() => props.logout()}
                >
                 
                 Hi, {props.USER ? props.USER.Name:""}
                </a> */}
                {/* <a
                  href="#pablo"
                  className={
                    "text-sm py-2 px-4 font-normal fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  // onClick={() => props.logout()}
                >
                 
                  {props.USER ? props.USER.MobileNo:""}
                </a> */}
                <a
                  href="#pablo"
                  className={
                    "text-sm py-2 px-4 font-normal fsize18 block w-full whitespace-nowrap bg-transparent " +
                    (color === "white" ? " text-blueGray-700" : "text-white")
                  }
                  onClick={() => props.logout()}
                >
                  Logout
                </a>

                <div className="h-0 my-2  opacity-25" />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Dropdown allprops={props} /> */}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    USER: state.Auth.user.USER_DETAILS_MG,
    Profile: state.Profile.home.SINGLEAPPLICANTINFO,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch({ type: "RESSET_STORE" }),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DropdownRender)
);
